import apiClient from './index';
import qs from 'qs';
import { FetchFileListProps } from '../pages/WorkspacePage';

interface FetchFileListResponse extends FetchFileListProps {
    ids: string[];
}

interface FetchFileListParams {
    pageSize?: number;
    page?: number;
    search?: string;
    startDate?: string;
    endDate?: string;
    northWest?: string;
    southEast?: string;
    geoPolygon?: string;
    tagName?: string[];
    campaignName?: string[];
    campaignId?: string;
    bandName?: string[];
    selectAll?: boolean;
}

export async function fetchFileList(
    {
        pageSize,
        page,
        search,
        startDate,
        endDate,
        northWest,
        southEast,
        geoPolygon,
        tagName,
        campaignName,
        campaignId,
        bandName,
        selectAll,
    }: FetchFileListParams
): Promise<FetchFileListResponse> {
    const params = {
        page_size: pageSize,
        page: page,
        search: search,
        start_date: startDate,
        end_date: endDate,
        northwest: northWest,
        southeast: southEast,
        geopolygon: geoPolygon,
        tag_name: tagName,
        campaign_name: campaignName,
        campaign_id: campaignId,
        band_name: bandName,
        select_all: selectAll,
    };

    const { data } = await apiClient.get('/sigcap/api/collections/', {
        params,
        paramsSerializer: (params) =>
            qs.stringify(params, {
                arrayFormat: 'comma',
                encodeValuesOnly: true,
                skipNulls: true,
            }),
    });
    return data;
}
